export default __webpack_public_path__ + "static/media/Z.8e980ebe.svg";